import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as moment_tz from 'moment-timezone';
import { environment } from 'src/environments/environment';
import { encrypt as input, decrypt as output } from 'crypto-js/aes';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from "crypto-js";
import { AuthService } from 'src/app/modules/auth/auth.service';
import { NotificationService } from '../services/notification.service';
import { PermissionService } from '../services/permission.service';

const cookieKey: string = "89701bb10aa7913";

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private authService: AuthService, private permission: PermissionService, private route: ActivatedRoute,private notifyService: NotificationService, private auth: AuthService, private router: Router, private cookieService: CookieService) { }

  private logoutPromise: Promise<void> | null = null;

  isLoggingOutNow(): boolean {
    return this.logoutPromise !== null;
  }

  Logout(skipApiCall: boolean = false): Promise<void> {
    if (this.logoutPromise) return this.logoutPromise;
    this.logoutPromise = this._runLogout(skipApiCall);
    return this.logoutPromise;
  }

  private async _runLogout(skipApiCall: boolean): Promise<void> {
    try {
      const token = this.authService.getToken();
      if (token && !skipApiCall) {
        try {
          const result: any = await this.auth.Logout().toPromise();
          if (result && result.code == 200) {
            this.notifyService.showSuccess('You have been successfully logged out!');
          }
        } catch (error) {
          console.error("Logout API failed", error);
        }
      }
      localStorage.setItem('logout', Date.now().toString());
      this.ClearStorageData();
      this.router.navigateByUrl("accounts/login");
    } finally {
      setTimeout(() => { this.logoutPromise = null; }, 3000);
    }
  }

  ClearStorageData() {
    localStorage.removeItem("customer_access_token");
    this.authService.clearToken();
    this.permission.clearPermissions();
    localStorage.removeItem("customer_refresh_token");
    localStorage.removeItem("customer_remember_me");
    localStorage.removeItem("customer_account_type");
    localStorage.removeItem("customer_projectType");
    localStorage.removeItem("customer_projectID");
    localStorage.removeItem("folderType");
    localStorage.removeItem("gerberFilePath");

    localStorage.removeItem("logout");
    localStorage.removeItem('quote_token');
    localStorage.removeItem("projectID");
    localStorage.removeItem("gerberFile");
    localStorage.removeItem("ID");
    localStorage.removeItem("currentStepIndex");
    localStorage.removeItem("isStepComplited");

    localStorage.removeItem("upload_gerber");
    localStorage.removeItem("projectType");

    this.cookieService.delete("customer_user", '/');
    this.cookieService.delete("customer_user", '/customer');
    this.cookieService.delete("customer_remember_me", '/');
    this.cookieService.delete("customer_remember_me", '/customer');
    this.clearAllCookies();

    // Clear for quotation
    localStorage.removeItem("user_name");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_DialCode");
    localStorage.removeItem("user_PhoneNo");
    localStorage.removeItem("customer_UserId");
  }

  GetCookieKey() {
    return cookieKey;
  }

  GetCookieData(): Promise<any> {
    return new Promise((resolve) => {
      try {
        if (this.cookieService.check("customer_user")) {
          const cookieData = this.cookieService.get("customer_user");
          const bytes = CryptoJS.AES.decrypt(cookieData, this.GetCookieKey());
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          if (decrypted) {
            resolve(JSON.parse(decrypted));
            return;
          }
        }
        // Cookie not found or empty
        resolve(null);
      } catch (err) {
        console.error('[Helper] Error reading cookie:', err);
        resolve(null);
      }
    });
  }

  clearAllCookies(): void {
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
  }


  //The Function Below To Encrypt Text
  staticPush(text: any) {
    const pp = environment.crypto_js.key;
    const convertData = input(text, pp).toString();
    const cText = convertData.replace('/', '1EAC09');
    return cText;
  }

  //The Function Below To Decrypt Text
  staticPop(cText: any) {
    const pp = environment.crypto_js.key;
    const tempText = cText.replace('1EAC09', '/');
    const bytes = output(tempText, pp);
    const oText = bytes.toString(CryptoJS.enc.Utf8);
    const text = JSON.parse(oText);
    return text;
  }

  //The Function Below To Encrypt Text
  dynamicPush(text: any) {
    // Get the current date in the Europe/London timezone
    const londonNow = moment_tz.tz("Europe/London");
    // Format the date in "DD/MM/YYYY" format
    const formattedDate = londonNow.format('DD/MM/YYYY');
    // Parse the formatted date back into a `moment` object in the Europe/London timezone
    const selectDate = moment_tz.tz(formattedDate, "DD/MM/YYYY", "Europe/London");
    // Convert and clone the date object to ensure it's still tied to Europe/London
    const tempDd = selectDate.clone();
    // Get the day of the week
    const weekday = tempDd.format("dddd");
    // Format the date and set the time to "00:00" explicitly
    const temp = tempDd.format('YYYY-MM-DD');
    const datetime = `${temp} 00:00`;
    // Get the epoch time (milliseconds since 1970-01-01T00:00:00Z)
    const epoch = moment_tz.tz(datetime, "Europe/London").valueOf();
    const pp = btoa(epoch + weekday);
    const convertData = input(text, pp).toString();
    const ctext = convertData.replace('/', '1EAC09');
    return ctext;
  }

  //The Function Below To Decrypt Text
  dynamicPop(ctext: any) {
    // Get the current date in the Europe/London timezone
    const londonNow = moment_tz.tz("Europe/London");
    // Format the date in "DD/MM/YYYY" format
    const formattedDate = londonNow.format('DD/MM/YYYY');
    // Parse the formatted date back into a `moment` object in the Europe/London timezone
    const selectDate = moment_tz.tz(formattedDate, "DD/MM/YYYY", "Europe/London");
    // Convert and clone the date object to ensure it's still tied to Europe/London
    const tempDd = selectDate.clone();
    // Get the day of the week
    const weekday = tempDd.format("dddd");
    // Format the date and set the time to "00:00" explicitly
    const temp = tempDd.format('YYYY-MM-DD');
    const datetime = `${temp} 00:00`;
    // Get the epoch time (milliseconds since 1970-01-01T00:00:00Z)
    const epoch = moment_tz.tz(datetime, "Europe/London").valueOf();  
    const pp = btoa(epoch + weekday);
    const tempText = ctext.replace('1EAC09', '/');
    const bytes = output(tempText, pp);
    const oText = bytes.toString(CryptoJS.enc.Utf8);
    const text = JSON.parse(oText);
    return text;
  }

}
